interface StatCardProps {
  label: string;
  value: string | number;
  bgColor?: string;
  textColor?: string;
}

export function StatCard({ label, value, bgColor = 'bg-gray-50', textColor = 'text-gray-700' }: StatCardProps) {
  return (
    <div className={`${bgColor} rounded-lg p-4`}>
      <div className={`text-sm font-medium ${textColor.replace('700', '900')}`}>{label}</div>
      <div className={`text-2xl font-bold ${textColor}`}>{value}</div>
    </div>
  );
}
